// extracted by mini-css-extract-plugin
export var advancedSearchLink = "SearchBar-module--advancedSearchLink--22287";
export var searchWrapper = "SearchBar-module--searchWrapper--88e08";
export var searchbar = "SearchBar-module--searchbar--64fb8";